export function handleInputChange(fields, e) {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
      fields[target.name] = value;

      return fields;
}

export function handleCustomInputChange(fields, idx, e) {

   const target = e.target;
   const value = target.type === 'checkbox' ? target.checked : target.value;

   if (target.type === "text") {
      fields.customFields[idx]['value'] = value;
   }

   else if (target.type === "checkbox") {
      fields.customFields[idx]['isRequired'] = value;
   }

   return fields;
}



// WEBPACK FOOTER //
// ./src/utils/FormHandler.js